if (!customElements.get("products-slider")) {
  customElements.define(
    "products-slider",
    class ProductsSliders extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.interval = setInterval(() => {
          const mainSliderContainer = this.querySelector(
            ".wt-products-slider__slider--products [data-swiper]",
          );
          const promoSliderContainer = this.querySelector(
            ".wt-products-slider__slider--promo [data-swiper]",
          );

          const mainSlider = mainSliderContainer?.swiper;
          const promoSlider = promoSliderContainer?.swiper;

          if (mainSlider && promoSlider) {
            clearInterval(this.interval);
            this.initializeSync(mainSlider, promoSlider);
          }
        }, 100);
      }

      initializeSync(mainSlider, promoSlider) {
        const updateCssVariables = (slider) => {
          const activeSlide = slider.slides[slider.activeIndex];

          if (activeSlide) {
            const activeSlideStyles = getComputedStyle(activeSlide);

            const cssVariableValue = activeSlideStyles
              .getPropertyValue("--slide-text-color")
              .trim();

            this.style.setProperty("--slider-bullets-color", cssVariableValue);
          }
        };

        const updateSaltyScalePagination = (activeIndex) => {
          // Remove active class from all salty scale dots (both desktop and mobile)
          const saltyDots = this.querySelectorAll('.salty-scale-dot');
          saltyDots.forEach(dot => dot.classList.remove('active'));
          
          // Add active class to current dot (both desktop and mobile)
          const activeDots = this.querySelectorAll(`.salty-scale-dot[data-slide-index="${activeIndex}"]`);
          activeDots.forEach(activeDot => {
            activeDot.classList.add('active');
          });
          
          // Update product title and CTA for both desktop and mobile
          const productTitles = this.querySelectorAll('.product-title');
          const productCtas = this.querySelectorAll('.product-cta');
          
          const activeDot = this.querySelector(`.salty-scale-dot[data-slide-index="${activeIndex}"]`);
          if (activeDot && productTitles.length > 0 && productCtas.length > 0) {
            const title = activeDot.getAttribute('data-product-title');
            const url = activeDot.getAttribute('data-product-url') || '#';
            
            // Update all product title and CTA elements (desktop and mobile)
            productTitles.forEach(productTitle => {
              productTitle.textContent = title;
            });
            
            productCtas.forEach(productCta => {
              productCta.setAttribute('href', url);
              productCta.setAttribute('aria-label', `Shop ${title}`);
            });
          }
        };

        const initializeSaltyScalePagination = () => {
          const saltyDots = this.querySelectorAll('.salty-scale-dot');
          
          saltyDots.forEach((dot, index) => {
            dot.addEventListener('click', () => {
              // Check if we're on mobile (promo slider visible) or desktop (main slider visible)
              const isMobile = window.innerWidth <= 768;
              
              if (isMobile) {
                // On mobile, only control the promo slider since that's what's visible
                promoSlider.slideTo(index);
              } else {
                // On desktop, control both sliders
                mainSlider.slideTo(index);
                promoSlider.slideTo(index);
              }
            });
          });
          
          // Set initial active state
          const initialIndex = mainSlider ? mainSlider.activeIndex : (promoSlider ? promoSlider.activeIndex : 0);
          updateSaltyScalePagination(initialIndex);
        };

        // Additional mobile-specific initialization
        const initializeMobileSaltyScale = () => {
          const mobileSaltyDots = this.querySelectorAll('.salty-scale-mobile .salty-scale-dot');
          
          mobileSaltyDots.forEach((dot, index) => {
            dot.addEventListener('click', () => {
              promoSlider.slideTo(index);
            });
          });
          
          // Set initial active state for mobile
          const isMobile = window.innerWidth <= 768;
          if (isMobile) {
            const initialIndex = promoSlider.activeIndex;
            updateSaltyScalePagination(initialIndex);
          }
        };

        updateCssVariables(mainSlider);
        updateCssVariables(promoSlider);
        
        // Initialize salty scale pagination
        initializeSaltyScalePagination();
        initializeMobileSaltyScale();

        // Handle resize events for mobile/desktop switching
        const handleResize = () => {
          const isMobile = window.innerWidth <= 768;
          const currentIndex = isMobile ? promoSlider.activeIndex : mainSlider.activeIndex;
          updateSaltyScalePagination(currentIndex);
        };

        window.addEventListener('resize', handleResize);

        mainSlider.on("slideChange", () => {
          promoSlider.slideTo(mainSlider.activeIndex);
          updateCssVariables(mainSlider);
          updateSaltyScalePagination(mainSlider.activeIndex);
        });

        promoSlider.on("slideChange", () => {
          // Only sync main slider on desktop
          if (window.innerWidth > 768) {
            mainSlider.slideTo(promoSlider.activeIndex);
          }
          updateCssVariables(promoSlider);
          updateSaltyScalePagination(promoSlider.activeIndex);
        });
      }

      disconnectedCallback() {
        if (this.interval) {
          clearInterval(this.interval);
        }
      }
    },
  );
}
